module.exports = __webpack_public_path__ + "static/media/BoutrosART-Medium.3db391ae.otf";